import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';

import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import { AutocompleteComponent } from './autocomplete.component';
import { UiComboboxModule } from '../combobox/combobox.module';

@NgModule({
  declarations: [AutocompleteComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgbDropdownModule, UiComboboxModule],
  exports: [AutocompleteComponent]
})
export class UiAutocompleteModule { }
